import VisaoGerencial from './VisaoGerencial';

export default VisaoGerencial;
